var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aspectWrapperContainer w-100",style:(_vm.paddingTop)},[_c('div',{staticClass:"aspectContent"},[_c('div',{staticClass:"w-100 h-100"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }